export const RESTRICTED_POA_STATES = [ 'FL', 'IN', 'KS', 'KY', 'LA', 'MD', 'MA', 'MI', 'MO', 'NJ', 'ND', 'OR', 'SC', 'SD', 'TN' ];
export const RESTRICTED_MEDICAL_CONSENT_STATES = [ 'FL' ];

export const isStateRestrictedForPOA = ( state: string | undefined ): boolean => {
  if ( !state ) {
    return false;
  }
  return RESTRICTED_POA_STATES.includes( state.toUpperCase());
};

export const isStateRestrictedForMedicalConsent = ( state: string | undefined ): boolean => {
  if ( !state ) {
    return false;
  }
  return RESTRICTED_MEDICAL_CONSENT_STATES.includes( state.toUpperCase());
};
